<script lang="ts">
  import { onDestroy, onMount } from 'svelte';

  let desktopCtaSubnavCtaWrappers: NodeListOf<HTMLElement>;
  let mobileCtaSubnavFooter: HTMLDivElement;
  let desktopCtaNav: HTMLDivElement;
  let observer: IntersectionObserver;

  function showElement(element: any) {
    if (!element || element.classList.contains('pw-next-visible')) {
      return;
    }

    element.classList.add('pw-next-visible');
  }

  function hideElement(element: any) {
    if (!element || !element.classList.contains('pw-next-visible')) {
      return;
    }

    element.classList.remove('pw-next-visible');
  }

  function pageCtaIntersectionObserverCallback(entries: any) {
    if (!desktopCtaSubnavCtaWrappers?.length) {
      return;
    }

    let isIntersecting = false;
    entries.forEach((entry: any) => {
      isIntersecting ||= entry.isIntersecting;
    });

    desktopCtaSubnavCtaWrappers.forEach((cta) => {
      isIntersecting ? hideElement(cta) : showElement(cta);
    });

    isIntersecting ? hideElement(mobileCtaSubnavFooter) : showElement(mobileCtaSubnavFooter);
    desktopCtaNav?.classList.toggle('isVisible', isIntersecting);
  }

  onMount(() => {
    let pageCtas: NodeListOf<Element> | undefined;

    mobileCtaSubnavFooter = document.querySelector(
      '.MobileNav .cta-button-container, .CtaSubnavMobileNav .footer'
    ) as HTMLDivElement;
    desktopCtaSubnavCtaWrappers = document.querySelectorAll(
      '.DesktopNav .cta-button-container .cta-button, .CtaSubnavDesktopNav .cta-item'
    );
    const subnavCtaLinks = document.querySelectorAll('.CtaSubnav a.Link--button, .CtaSubnav a.ButtonLink');
    desktopCtaNav = document.querySelector('.global-nav-ctas') as HTMLDivElement;

    if (subnavCtaLinks.length > 0) {
      const ctaLinkHrefs = Array.from(subnavCtaLinks)
        .map((e) => {
          const href: any = e.getAttribute('href');
          try {
            return new URL(href, document.baseURI).pathname;
          } catch {
            return null;
          }
        })
        .filter(Boolean);
      const pageCtaSelector = ctaLinkHrefs.map((href) => `[href^="${href}"]`).join(',');

      // PWR places header in the main content wrapper, and header also includes pageCtaSelector.
      // so move this query to the main page content (.BasePage) to avoid selecting the header
      const mainContent = document.querySelector('.BasePage');
      if (mainContent) {
        pageCtas = mainContent.querySelectorAll(pageCtaSelector);
      }
    }

    if (pageCtas) {
      observer = new IntersectionObserver(pageCtaIntersectionObserverCallback);
      pageCtas.forEach((cta) => {
        observer.observe(cta);
      });
    }
  });

  onDestroy(() => {
    observer?.disconnect();
  });
</script>

<style lang="scss">
  :global {
    .CtaSubnavDesktopNav,
    .DesktopNav {
      .right-slot .nav-list,
      .cta-subnav-list {
        justify-content: flex-end;
      }

      .cta-button-container {
        transition: max-width var(--duration-quick) var(--easing-decelerate);
      }

      .cta-button-container:not(:has(.pw-next-visible)) {
        max-width: 0;
      }

      .cta-button-container:has(.pw-next-visible) {
        max-width: 100%;
      }

      li.cta-item,
      li.cta-button {
        &,
        &.hidden {
          display: block !important;
          max-width: 0% !important;
          opacity: 0 !important;
          padding-left: 0 !important;
        }

        transform: translateY(100%) !important;
        transition:
          transform calc(var(--duration-quick) / 2) var(--easing-sharp),
          opacity calc(var(--duration-quick) / 2) var(--easing-sharp),
          max-width var(--duration-quick) var(--easing-decelerate) !important;

        &.pw-next-visible {
          padding-left: 10px !important;
          max-width: 100% !important;
          opacity: 1 !important;
          transform: translateY(0%) !important;
          transition:
            max-width var(--duration-default) var(--easing-decelerate),
            transform var(--duration-quick) var(--easing-sharp),
            opacity var(--duration-quick) var(--easing-sharp) !important;
        }
      }
    }

    // Only remove padding left from subnav v2 under nav v2
    .PublicWebNavV2 {
      .CtaSubnavDesktopNav,
      .DesktopNav {
        .cta-subnav-container {
          li.cta-item,
          li.cta-button {
            &.pw-next-visible {
              padding-left: 0px !important;
            }
          }
        }
      }
    }

    // Transition values from public-web-nav
    .CtaSubnavMobileNav,
    .MobileNav {
      .footer,
      .cta-button-container {
        transform: translateY(100%) !important;
        transition: transform 75ms cubic-bezier(0.4, 0, 1, 1) !important;

        &.pw-next-visible {
          transform: translateY(0%) !important;
          transition: transform 150ms cubic-bezier(0, 0, 0.2, 1) !important;
        }
      }
    }
  }
</style>
